// src/components/Header/SettingsButton.jsx
//
// Rotița din josul meniului (lângă temă și ieșire): deschide fereastra
// „Setări” a elevului. Același aspect ca butoanele vecine.

import React from "react";
import { ReactSVG } from "react-svg";

import { openPopup } from "../Common/popupUIStore";
import cogIcon from "../../assets/svg/mdi--cog-outline.svg";

export default function SettingsButton() {
   return (
      <li className="settings__item">
         <button
            type="button"
            className="settings__mode-btn"
            aria-label="Setări"
            title="Setări"
            onClick={() => openPopup("appearanceSettings")}
         >
            <div className="settings__icons">
               <ReactSVG className="settings__icon-gear" src={cogIcon} />
            </div>
         </button>
      </li>
   );
}
